/**
 * Per-Gebäudetyp follow-up rules for the Einheiten-Detail step.
 * Field keys are stable so summary/edit logic can reference them.
 */

export type UnitFieldKind =
  | "flaeche"
  | "geschoss"
  | "nutzung"
  | "mietWohnGewerbe"
  | "mieteinnahmen"
  | "nebenkosten"
  | "vorsteuerJa"
  | "vorsteuerProzent"
  | "mietvertragJa"
  | "mietvertragWelche"
  | "mietereinbautenJa"
  | "mietereinbautenWas"
  | "mietereinbautenWert"
  | "mietereinbautenBesitz"
  | "mietereinbautenMitversichern";

export type UnitProfile = {
  countLocked?: number;
  showEinliegerwohnung?: boolean;
  fields: UnitFieldKind[];
};

export const WOHN_BASE: UnitFieldKind[] = ["flaeche", "geschoss"];
export const WOHN_FERIEN: UnitFieldKind[] = ["flaeche", "nutzung", "geschoss"];
export const GEWERBE_FULL: UnitFieldKind[] = [
  "flaeche",
  "nutzung",
  "geschoss",
  "mieteinnahmen",
  "nebenkosten",
  "vorsteuerJa",
  "vorsteuerProzent",
  "mietvertragJa",
  "mietvertragWelche",
  "mietereinbautenJa",
  "mietereinbautenWas",
  "mietereinbautenWert",
  "mietereinbautenBesitz",
  "mietereinbautenMitversichern",
];
export const MISCH_FULL: UnitFieldKind[] = [
  "mietWohnGewerbe",
  ...GEWERBE_FULL,
];

export const profileForType = (
  kategorie: string | undefined,
  typ: string | undefined
): UnitProfile => {
  if (kategorie === "Mischnutzung (Wohnen u. Gewerbe)") {
    return { fields: MISCH_FULL };
  }
  if (kategorie === "Gewerbe (100%)") {
    return { fields: GEWERBE_FULL };
  }
  // Wohnen
  if (typ === "Einfamilienhaus") {
    return { countLocked: 1, showEinliegerwohnung: true, fields: [] };
  }
  if (typ === "Zweifamilienhaus") {
    return { countLocked: 2, showEinliegerwohnung: true, fields: [] };
  }
  if (typ === "Ferienimmobilie") {
    return { fields: WOHN_FERIEN };
  }
  return { fields: WOHN_BASE };
};

export const labelFor: Record<UnitFieldKind, string> = {
  flaeche: "Fläche (m²)",
  geschoss: "Geschoss",
  nutzung: "Nutzung",
  mietWohnGewerbe: "Wohnen oder Gewerbe?",
  mieteinnahmen: "Mieteinnahmen (€)",
  nebenkosten: "Nebenkosten (€)",
  vorsteuerJa: "Vorsteuerabzugsberechtigt?",
  vorsteuerProzent: "Vorsteuer (%)",
  mietvertragJa: "Mietvertragliche Verpflichtungen?",
  mietvertragWelche: "Welche?",
  mietereinbautenJa: "Mietereinbauten vorhanden?",
  mietereinbautenWas: "Was?",
  mietereinbautenWert: "Wert (€)",
  mietereinbautenBesitz: "In wessen Besitz?",
  mietereinbautenMitversichern: "Interesse, mitzuversichern?",
};
